<div *ngIf="filter" class="py-4 flex flex-wrap items-center gap-2.5">
  <app-filter-where-label></app-filter-where-label>
  <ng-container
    *ngFor="
      let filterModel of filter.filters;
      let i = index;
      trackBy: trackByFilter
    ">
    <ng-container [ngSwitch]="filterModel.filterType">
      <app-event-property-filter
        *ngSwitchCase="FilterType.EventProperty"
        [eventName]="eventName"
        [eventProperty]="filterModel"
        (update)="updateFilter($event)"
        (remove)="removeFilter(i)">
      </app-event-property-filter>
      <app-filter-group
        *ngSwitchCase="FilterType.FilterGroup"
        class="block w-full"
        [eventName]="eventName"
        [allowedFilters]="allowedFilterGroupFilters"
        [filterGroup]="toFilterGroupFilterType(filterModel)"
        (update)="updateFilter($event)"
        (remove)="removeFilter(i)">
      </app-filter-group>
    </ng-container>
    <app-relationship-switcher
      *ngIf="i !== filter.filters.length - 1"
      [active]="filter.operator"
      (toggle)="toggleRelationshipSwitcher($event)">
    </app-relationship-switcher>
  </ng-container>
  <app-add-filter-button
    dropdownTitle="page trigger"
    [filters]="allowedFilters"
    (add)="addFilter($event)">
  </app-add-filter-button>
</div>
